<div class="app-bank-transfer">
  <form
    (ngSubmit)="makePayment()"
    [formGroup]="form"
    [ngClass]="{'app-bank-transfer-form-has-extra': hasAdditionalInfo}"
    class="app-bank-transfer-form"
    nz-form
    nzLayout="vertical"
  >
    <div class="app-bank-transfer-form-main">
      <app-image class="app-bank-transfer-form-main-icon" name="banktransfer"></app-image>

      <app-beneficiary-name-input
        (beneficiarySelected)="handleBeneficiarySelected($event)"
        [beneficiaryNameControl]="form.get('beneficiaryName')"
        [beneficiaryNameMaxLength]="config.beneficiaryNameMaxLength"
        [beneficiaryNameMinLength]="config.beneficiaryNameMinLength"
        [nzExtra]="beneficiaryNameExtra$ | async"
      ></app-beneficiary-name-input>

      <app-beneficiary-account-number-input
        (institutionChange)="onInstitution($event)"
        (userMustProvideInstitution)="onUserMustProvideInstitution($event)"
        (validating)="onInstitutionValidating($event)"
        [beneficiaryAccountNumberControl]="form.get('beneficiaryAccountNumber')"
        [beneficiaryAccountNumberMaxLength]="config.beneficiaryAccountNumberMaxLength"
        [beneficiaryAccountNumberMinLength]="config.beneficiaryAccountNumberMinLength"
        [institutionValidating]="institutionValidating"
        [institution]="institution"
        [selectedBeneficiary]="selectedBeneficiary"
      ></app-beneficiary-account-number-input>

      <app-beneficiary-bank-details
        (institutionSelected)="onBeneficiaryBankInstitutionSelected($event)"
        [beneficiaryBankAddressControl]="form.get('beneficiaryBankAddress')"
        [beneficiaryBankCountryControl]="form.get('beneficiaryBankCountry')"
        [beneficiaryBankIdentifierControl]="form.get('beneficiaryBankIdentifier')"
        [beneficiaryBankNameControl]="form.get('beneficiaryBankName')"
        [config]="config"
        [form]="form"
        [userMustProvideInstitution]="userMustProvideInstitution"
      ></app-beneficiary-bank-details>

      <nz-form-item>
        <nz-form-label translate>payment.payerAccount.label</nz-form-label>
        <nz-form-control>
          <app-account-select
            [accountNameLookup]="true"
            [formControl]="payerAccountControl"
            [nzPlaceHolder]="'payment.payerAccount.placeholder' | translate: locale.language"
            [onlyPositiveAmountsSelectable]="!scheduled && !waitForFunds"
            data-cy="payment-account-select"
            nzSize="large"
          ></app-account-select>
        </nz-form-control>
      </nz-form-item>

      @if (waitForFundsEnabled) {
      <nz-form-item>
        <nz-form-control>
          <label formControlName="waitForFunds" nz-checkbox translate>payment.waitForFunds.label</label>
        </nz-form-control>
      </nz-form-item>
      } @if (feeAccountEnabled) {
      <nz-form-item>
        <nz-form-label translate>payment.feeAccount.label</nz-form-label>
        <nz-form-control>
          <app-account-select
            [accountNameLookup]="true"
            [error]="paymentConditions?.feeAccountError"
            [formControl]="feeAccountControl"
            [nzPlaceHolder]="'payment.feeAccount.placeholder' | translate: locale.language"
            [onlyPositiveAmountsSelectable]="false"
            data-cy="payment-fee-account-select"
            nzSize="large"
          ></app-account-select>
        </nz-form-control>
      </nz-form-item>
      }

      <app-payment-amount
        (amountFocusChange)="onPaymentAmountFocusChange('amount', $event)"
        (exchangeAmountFocusChange)="onPaymentAmountFocusChange('exchangeAmount', $event)"
        [allowCurrencySelection]="canSelectGatewayCurrency"
        [amountControl]="amountControl"
        [currencies]="currencies"
        [currencyControl]="currencyControl"
        [exchangeAmountControl]="initialAmountControl"
        [exchangeCurrencyControl]="initialCurrencyControl"
        [form]="form"
        [paymentConditions]="paymentConditions"
        [paymentConfig]="config"
        [showReadOnlyCurrency]="showReadOnlyCurrency"
        [shouldShowExchangeAmount]="displayExchangeAmount$ | async"
      ></app-payment-amount>

      <app-instruction-identification
        [form]="form"
        [instructionCodes$]="instructionCodes$"
        [instructionIdentificationControl]="form.get('instructionIdentification')"
        [isInstructionIdentificationEnabled]="isInstructionIdentificationEnabled"
        [paymentConditions]="paymentConditions"
      ></app-instruction-identification>

      <app-service-charge-details
        [form]="form"
        [serviceChargeDetails$]="serviceChargeDetails$"
        [serviceChargeDetailsControl]="form.get('serviceChargeDetails')"
        [userCanProvideServiceChargeDetails]="userCanProvideServiceChargeDetails"
      ></app-service-charge-details>

      <app-payment-details
        (switchPaymentDetailsType)="switchPaymentDetailsType($event)"
        [config]="config"
        [isPaymentDetailsStructured]="isPaymentDetailsStructured"
        [paymentCodeControl]="form.get('paymentCode')"
        [paymentDetailsControl]="form.get('paymentDetails')"
      ></app-payment-details>

      @if (attachmentsEnabled) {
      <nz-form-item>
        <app-file-upload (changed)="onAttachmentsChange($event)" (uploading)="fileUploading($event)" [files]="payment?.attachments"></app-file-upload>
      </nz-form-item>
      } @if (canHaveAdditionalInfo) {
      <nz-form-item>
        <nz-form-control>
          <label nz-checkbox formControlName="hasAdditionalInfo" translate>payment.additionalInformation</label>
        </nz-form-control>
      </nz-form-item>
      }

      <ng-container *ngTemplateOutlet="scheduledPaymentTemplate"></ng-container>
    </div>

    @if (hasAdditionalInfo) { } @else {
    <div class="app-bank-transfer-form-buttons">
      @if (payeeVerificationInlineState$ | async; as payeeVerificationInlineState) { @if (payeeVerificationInlineState !== PayeeVerificationInlineState.IDLE) {
      <div class="app-bank-transfer-form-buttons-vop" data-cy="payment-vop-status">
        <i class="app-bank-transfer-form-buttons-vop-spinner" nz-icon nzType="loading" [nzSpin]="true"></i>
        <span data-cy="payment-vop-status-message">{{ payeeVerificationInlineMessageKey | translate: locale.language }}</span>
      </div>
      } }
      <app-alert [userAgreementControl]="alertAgreementControl" #alertRef [form]="form"></app-alert>
      <button
        [disabled]="isSubmitButtonDisabled(submitButtonDisabled$ | async)"
        [nzLoading]="submitButtonLoading$ | async"
        data-cy="payment-submit-button"
        nz-button
        nzSize="large"
        nzType="primary"
        type="submit"
      >
        {{ (payment?.editStandingOrderId ? 'payment.updatePayment' : 'payment.makePayment') | translate: locale.language }}
      </button>
      @if ((saveButtonVisible$ | async) && canBeSaved()) {
      <button
        (click)="save()"
        [disabled]="isSaveButtonDisabled(saveButtonDisabled$ | async)"
        [nzLoading]="saveButtonLoading$ | async"
        nz-button
        nzType="link"
        translate
        type="button"
      >
        payment.save
      </button>
      }
    </div>
    } @if (hasAdditionalInfo) {
    <div class="app-bank-transfer-form-extra">
      @if (isPaymentSwift) {
      <h3 nz-typography translate>payment.receiverInfo.title</h3>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('swiftBeneficiaryAddress', swiftBeneficiaryAddressSectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('swiftBeneficiaryAddress', $event)"
        [headerKey]="'payment.receiverInfo.address.title'"
      >
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.address.address.label</nz-form-label>
          <nz-form-control>
            <input
              [maxlength]="config.beneficiaryAddressMaxLength"
              [placeholder]="'payment.receiverInfo.address.address.placeholder' | translate: locale.language"
              formControlName="beneficiaryAddress"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
      </app-collapse>
      <app-collapse [active]="true" [headerKey]="'payment.receiverInfo.correspondentBank.title'">
        <app-correspondent-bank-information
          (institutionSelected)="onInstitutionSelect($event, 'correspondentBankName', 'correspondentBankAddress')"
          [config]="config"
          [correspondentBankAddressControl]="form.get('correspondentBankAddress')"
          [correspondentBankCodeControl]="form.get('correspondentBankCode')"
          [correspondentBankIdentifierControl]="form.get('correspondentBankIdentifier')"
          [correspondentBankNameControl]="form.get('correspondentBankName')"
          [useSwiftBicCodeLabel]="swiftPaymentBicNamingAndPostalCodeInfoEnabled"
        ></app-correspondent-bank-information>
      </app-collapse>
      } @if (displaySepaFields && !isGatewayPaymentInitiated) {
      <h3 nz-typography translate>payment.payerInfo.title</h3>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('paymentIdentification', paymentIdentificationSectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('paymentIdentification', $event)"
        [headerKey]="'payment.payerInfo.paymentIdentification.title'"
      >
        <nz-form-item>
          <nz-form-label translate>payment.payerInfo.paymentIdentification.id.label</nz-form-label>
          <nz-form-control>
            <input
              [maxLength]="config.paymentIdentificationMaxLength"
              [placeholder]="'payment.payerInfo.paymentIdentification.id.placeholder' | translate: locale.language"
              formControlName="paymentIdentification"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <label formControlName="sendPayerAddress" nz-checkbox translate>payment.payerInfo.paymentIdentification.sendPayerAddress.label</label>
          </nz-form-control>
        </nz-form-item>
      </app-collapse>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('payerIdentification', payerIdentificationSectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('payerIdentification', $event)"
        [headerKey]="'payment.payerInfo.payerIdentification.title'"
      >
        <ng-container *ngTemplateOutlet="payerIdentificationTemplate"></ng-container>
      </app-collapse>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('initialPayer', initialPayerSectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('initialPayer', $event)"
        [headerKey]="'payment.payerInfo.initial.title'"
      >
        <nz-form-item>
          <nz-form-label translate>payment.payerInfo.initial.title</nz-form-label>
          <nz-form-control>
            <input
              [placeholder]="'payment.payerInfo.initial.placeholder' | translate: locale.language"
              formControlName="initialPayerName"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        <app-collapse [headerKey]="'payment.payerInfo.identify.title'">
          <ng-container *ngTemplateOutlet="initialPayerIdentificationTemplate"></ng-container>
        </app-collapse>
      </app-collapse>
      <h3 nz-typography translate>payment.receiverInfo.title</h3>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('beneficiaryAddress', beneficiaryAddressSectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('beneficiaryAddress', $event)"
        [headerKey]="'payment.receiverInfo.address.title'"
      >
        @if (isPaymentAddressStructured) {
        <app-payment-address
          [buildingNameControl]="form.get('beneficiaryBuildingName')"
          [buildingNameMaxLength]="STRUCTURED_ADDRESS_BUILDING_NAME_MAX_LENGTH"
          [buildingNumberControl]="form.get('beneficiaryBuildingNumber')"
          [buildingNumberMaxLength]="STRUCTURED_ADDRESS_BUILDING_NUMBER_MAX_LENGTH"
          [cityControl]="form.get('beneficiaryCity')"
          [cityMaxLength]="STRUCTURED_ADDRESS_CITY_MAX_LENGTH"
          [countryControl]="form.get('beneficiaryCountry')"
          [postalCodeControl]="form.get('beneficiaryPostalCode')"
          [postalCodeMaxLength]="STRUCTURED_ADDRESS_POSTAL_CODE_MAX_LENGTH"
          [showPostalCodeRequiredInfoIcon]="swiftPaymentBicNamingAndPostalCodeInfoEnabled"
          [provinceControl]="form.get('beneficiaryProvince')"
          [provinceMaxLength]="STRUCTURED_ADDRESS_PROVINCE_MAX_LENGTH"
          [streetControl]="form.get('beneficiaryStreetName')"
          [streetMaxLength]="STRUCTURED_ADDRESS_STREET_NAME_MAX_LENGTH"
          [structuredAddressEnabled]="paymentConditions.structuredAddressEnabled"
          data-cy="beneficiary-address"
        ></app-payment-address>
        } @else {
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.address.country.label</nz-form-label>
          <nz-form-control>
            <nz-select
              [nzPlaceHolder]="'payment.receiverInfo.address.country.placeholder' | translate: locale.language"
              formControlName="beneficiaryCountry"
              l10n-placeholder
              nzShowSearch
              nzSize="large"
            >
              @for (country of countries$ | async; track country.id) {
              <nz-option [nzLabel]="country.label" [nzValue]="country.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.address.address.label</nz-form-label>
          <nz-form-control>
            <input
              [maxlength]="config.beneficiaryAddressMaxLength"
              [placeholder]="'payment.receiverInfo.address.address.placeholder' | translate: locale.language"
              formControlName="beneficiaryAddress"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        }
      </app-collapse>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('beneficiaryIdentification', beneficiaryIdentificationSectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('beneficiaryIdentification', $event)"
        [headerKey]="'payment.receiverInfo.identification.title'"
      >
        <ng-container *ngTemplateOutlet="beneficiaryIdentificationTemplate"></ng-container>
      </app-collapse>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('ultimateBeneficiary', ultimateBeneficiarySectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('ultimateBeneficiary', $event)"
        [headerKey]="'payment.receiverInfo.ultimate.title'"
      >
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.ultimate.title</nz-form-label>
          <nz-form-control>
            <input
              [placeholder]="'payment.receiverInfo.ultimate.placeholder' | translate: locale.language"
              formControlName="ultimateBeneficiaryName"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        <app-collapse [headerKey]="'payment.receiverInfo.identify.title'">
          <ng-container *ngTemplateOutlet="ultimateBeneficiaryIdentificationTemplate"></ng-container>
        </app-collapse>
      </app-collapse>
      } @if (isGatewayPaymentInitiated) {
      <app-payment-gateway-info
        [PaymentIdentificationClasses]="PaymentIdentificationClasses"
        [beneficiaryCategory]="beneficiaryCategory"
        [collapsed]="collapsed"
        [config]="config"
        [countries$]="countries$"
        [form]="form"
        [gatewayAdditionalControlNames]="gatewayAdditionalControlNames"
        [paymentConditions]="gatewayPaymentConditions"
        [shouldShowExchangeAmount]="displayExchangeAmount$ | async"
        [payerIdentificationTemplate]="payerIdentificationTemplate"
        [initialPayerIdentificationTemplate]="initialPayerIdentificationTemplate"
        [beneficiaryIdentificationTemplate]="beneficiaryIdentificationTemplate"
        [ultimateBeneficiaryIdentificationTemplate]="ultimateBeneficiaryIdentificationTemplate"
      ></app-payment-gateway-info>
      } @if (isPaymentCurrencyCloud ) {
      <h3 nz-typography translate>payment.receiverInfo.title</h3>
      @if (currencyCloudControlNameExists('beneficiaryIdentification')) {
      <app-collapse [active]="!collapsed" [headerKey]="'payment.receiverInfo.beneficiary.title'">
        <app-payment-identification
          [idControl]="form.get('beneficiaryId')"
          [identificationClassControl]="form.get('beneficiaryIdentification')"
          [identificationCodeTypeControl]="form.get('beneficiaryIdentificationDocument')"
          [identificationTypeControl]="form.get('beneficiaryIdentificationType')"
          [beneficiaryNameControl]="form.get('beneficiaryName')"
          [nameControlAvailable]="currencyCloudControlNameExists('beneficiaryIdentificationName')"
          [surnameControlAvailable]="currencyCloudControlNameExists('beneficiaryIdentificationSurname')"
          [nameControl]="form.get('beneficiaryIdentificationName')"
          [placeholder]="'payment.receiverInfo.identification.placeholder' | translate: locale.language"
          [surnameControl]="form.get('beneficiaryIdentificationSurname')"
          [paymentType]="paymentConditions?.operationType"
          [allowedClasses]="allowedBeneficiaryIdentificationValues"
        ></app-payment-identification>
      </app-collapse>
      } @if (displayCurrencyCloudAddressLabel()) {
      <app-collapse [active]="!collapsed" [headerKey]="'payment.receiverInfo.address.title'">
        @if (currencyCloudControlNameExists('beneficiaryCountry')) {
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.address.country.label</nz-form-label>
          <nz-form-control>
            <nz-select
              [nzPlaceHolder]="'payment.receiverInfo.address.country.placeholder' | translate: locale.language"
              formControlName="beneficiaryCountry"
              l10n-placeholder
              nzShowSearch
              nzSize="large"
            >
              @for (country of countries$ | async; track country.id) {
              <nz-option [nzLabel]="country.label" [nzValue]="country.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        } @if (currencyCloudControlNameExists('beneficiaryProvince')) {
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.address.province.label</nz-form-label>
          <nz-form-control>
            <input
              [maxlength]="config.identificationProvinceOfBirthMaxLength"
              [placeholder]="'payment.receiverInfo.address.province.placeholder' | translate: locale.language"
              formControlName="beneficiaryProvince"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        } @if (currencyCloudControlNameExists('beneficiaryCity')) {
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.address.city.label</nz-form-label>
          <nz-form-control>
            <input
              [maxlength]="config.identificationCityOfBirthMaxLength"
              [placeholder]="'payment.receiverInfo.address.city.placeholder' | translate: locale.language"
              formControlName="beneficiaryCity"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        } @if (currencyCloudControlNameExists('beneficiaryPostalCode')) {
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.address.postalCode.label</nz-form-label>
          <nz-form-control>
            <input
              [maxlength]="config.beneficiaryPostalCodeMaxLength"
              [placeholder]="'payment.receiverInfo.address.postalCode.placeholder' | translate: locale.language"
              formControlName="beneficiaryPostalCode"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        } @if (currencyCloudControlNameExists('beneficiaryAddress')) {
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.address.address.label</nz-form-label>
          <nz-form-control>
            <input
              [maxlength]="config.beneficiaryBankAddressMaxLength"
              [placeholder]="'payment.receiverInfo.address.address.placeholder' | translate: locale.language"
              formControlName="beneficiaryAddress"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        }
      </app-collapse>
      } @if (paymentConditions?.customFields?.length) { @for (customField of paymentConditions.customFields; track customField.glossaryId) {
      <nz-form-item formGroupName="customFields">
        <nz-form-label>{{ customField.label }}</nz-form-label>
        <nz-form-control>
          <input [formControlName]="customField.name" [placeholder]="customField.label" [type]="customField.type" nz-input nzSize="large" />
        </nz-form-control>
      </nz-form-item>
      } } } @if (isPaymentSwiftXml || isPaymentTarget2) {
      <h3 nz-typography translate>payment.payerInfo.title</h3>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('swiftXmlPaymentIdentification', swiftXmlPaymentIdentificationSectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlPaymentIdentification', $event)"
        [headerKey]="'payment.payerInfo.paymentIdentification.title'"
      >
        <nz-form-item>
          <nz-form-label translate>payment.payerInfo.paymentIdentification.id.label</nz-form-label>
          <nz-form-control>
            <input
              [maxLength]="config.paymentIdentificationMaxLength"
              [placeholder]="'payment.payerInfo.paymentIdentification.id.placeholder' | translate: locale.language"
              formControlName="paymentIdentification"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
      </app-collapse>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('swiftXmlPayerIdentification', payerIdentificationSectionControlNames, payerIdentificationMandatory)"
        (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlPayerIdentification', $event)"
        [headerKey]="'payment.payerInfo.payerIdentification.title'"
      >
        <ng-container *ngTemplateOutlet="payerIdentificationTemplate"></ng-container>
      </app-collapse>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('swiftXmlInitialPayer', initialPayerSectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlInitialPayer', $event)"
        [headerKey]="'payment.payerInfo.initial.title'"
      >
        <nz-form-item>
          <nz-form-label translate>payment.payerInfo.initial.subtitle</nz-form-label>
          <nz-form-control>
            <input
              [placeholder]="'payment.payerInfo.initial.placeholder' | translate: locale.language"
              formControlName="initialPayerName"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        <app-collapse
          [active]="isAdditionalInfoSectionActive('swiftXmlInitialPayerIdentification', initialPayerIdentificationSectionControlNames)"
          (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlInitialPayerIdentification', $event)"
          [headerKey]="'payment.payerInfo.identify.title'"
        >
          <ng-container *ngTemplateOutlet="initialPayerIdentificationTemplate"></ng-container>
        </app-collapse>
        <app-collapse
          [active]="isAdditionalInfoSectionActive('swiftXmlInitialPayerAddress', initialPayerAddressControlNames)"
          (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlInitialPayerAddress', $event)"
          [headerKey]="'payment.payerInfo.initial.address.title'"
        >
          @if (isPaymentAddressStructured) {
          <app-payment-address
            [buildingNameControl]="form.get('initialPayerBuildingName')"
            [buildingNameMaxLength]="STRUCTURED_ADDRESS_BUILDING_NAME_MAX_LENGTH"
            [buildingNumberControl]="form.get('initialPayerBuildingNumber')"
            [buildingNumberMaxLength]="STRUCTURED_ADDRESS_BUILDING_NUMBER_MAX_LENGTH"
            [cityControl]="form.get('initialPayerCity')"
            [cityMaxLength]="STRUCTURED_ADDRESS_CITY_MAX_LENGTH"
            [countryControl]="form.get('initialPayerCountry')"
            [postalCodeControl]="form.get('initialPayerPostalCode')"
            [postalCodeMaxLength]="STRUCTURED_ADDRESS_POSTAL_CODE_MAX_LENGTH"
            [showPostalCodeRequiredInfoIcon]="swiftPaymentBicNamingAndPostalCodeInfoEnabled"
            [provinceControl]="form.get('initialPayerProvince')"
            [provinceMaxLength]="STRUCTURED_ADDRESS_PROVINCE_MAX_LENGTH"
            [streetControl]="form.get('initialPayerStreetName')"
            [streetMaxLength]="STRUCTURED_ADDRESS_STREET_NAME_MAX_LENGTH"
            [structuredAddressEnabled]="isPaymentAddressStructured"
            data-cy="initial-payer-address"
          ></app-payment-address>
          } @else {
          <app-payment-address
            [cityControl]="form.get('initialPayerCity')"
            [countryControl]="form.get('initialPayerCountry')"
            [postalCodeControl]="form.get('initialPayerPostalCode')"
            [showPostalCodeRequiredInfoIcon]="swiftPaymentBicNamingAndPostalCodeInfoEnabled"
            [provinceControl]="form.get('initialPayerProvince')"
            data-cy="initial-payer-address"
          ></app-payment-address>
          }
        </app-collapse>
      </app-collapse>
      <h3 nz-typography translate>payment.receiverInfo.title</h3>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('swiftXmlBeneficiaryAddress', beneficiaryAddressSectionControlNames, beneficiaryAddressFieldsMandatory)"
        (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlBeneficiaryAddress', $event)"
        [headerKey]="'payment.receiverInfo.address.title'"
      >
        @if (isPaymentAddressStructured) {
        <app-payment-address
          [addressFieldsMandatory]="beneficiaryAddressFieldsMandatory"
          [buildingNameControl]="form.get('beneficiaryBuildingName')"
          [buildingNameMaxLength]="STRUCTURED_ADDRESS_BUILDING_NAME_MAX_LENGTH"
          [buildingNumberControl]="form.get('beneficiaryBuildingNumber')"
          [buildingNumberMaxLength]="STRUCTURED_ADDRESS_BUILDING_NUMBER_MAX_LENGTH"
          [cityControl]="form.get('beneficiaryCity')"
          [cityMaxLength]="STRUCTURED_ADDRESS_CITY_MAX_LENGTH"
          [countryControl]="form.get('beneficiaryCountry')"
          [postalCodeControl]="form.get('beneficiaryPostalCode')"
          [postalCodeMaxLength]="STRUCTURED_ADDRESS_POSTAL_CODE_MAX_LENGTH"
          [showPostalCodeRequiredInfoIcon]="swiftPaymentBicNamingAndPostalCodeInfoEnabled"
          [provinceControl]="form.get('beneficiaryProvince')"
          [provinceMaxLength]="STRUCTURED_ADDRESS_PROVINCE_MAX_LENGTH"
          [streetControl]="form.get('beneficiaryStreetName')"
          [streetMaxLength]="STRUCTURED_ADDRESS_STREET_NAME_MAX_LENGTH"
          [structuredAddressEnabled]="isPaymentAddressStructured"
          data-cy="beneficiary-address"
        ></app-payment-address>
        } @else {
        <app-payment-address
          [addressFieldsMandatory]="beneficiaryAddressFieldsMandatory"
          [cityControl]="form.get('beneficiaryCity')"
          [countryControl]="form.get('beneficiaryCountry')"
          [postalCodeControl]="form.get('beneficiaryPostalCode')"
          [showPostalCodeRequiredInfoIcon]="swiftPaymentBicNamingAndPostalCodeInfoEnabled"
          [provinceControl]="form.get('beneficiaryProvince')"
          data-cy="beneficiary-address"
        ></app-payment-address>
        }
      </app-collapse>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('swiftXmlBeneficiaryIdentification', beneficiaryIdentificationSectionControlNames, beneficiaryIdentificationMandatory)"
        (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlBeneficiaryIdentification', $event)"
        [headerKey]="'payment.receiverInfo.identification.title'"
      >
        <ng-container *ngTemplateOutlet="beneficiaryIdentificationTemplate"></ng-container>
      </app-collapse>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('swiftXmlUltimateBeneficiary', ultimateBeneficiarySectionControlNames, ultimateBeneficiaryIdentificationMandatory)"
        (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlUltimateBeneficiary', $event)"
        [headerKey]="'payment.receiverInfo.ultimate.title'"
      >
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.ultimate.subtitle</nz-form-label>
          <nz-form-control>
            <input
              [placeholder]="'payment.receiverInfo.ultimate.placeholder' | translate: locale.language"
              formControlName="ultimateBeneficiaryName"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        <app-collapse
          [active]="isAdditionalInfoSectionActive('swiftXmlUltimateBeneficiaryIdentification', ultimateBeneficiaryIdentificationSectionControlNames, ultimateBeneficiaryIdentificationMandatory)"
          (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlUltimateBeneficiaryIdentification', $event)"
          [headerKey]="'payment.receiverInfo.identify.title'"
        >
          <ng-container *ngTemplateOutlet="ultimateBeneficiaryIdentificationTemplate"></ng-container>
        </app-collapse>
        <app-collapse
          [active]="isAdditionalInfoSectionActive('swiftXmlUltimateBeneficiaryAddress', ultimateBeneficiaryAddressControlNames)"
          (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlUltimateBeneficiaryAddress', $event)"
          [headerKey]="'payment.receiverInfo.ultimate.address.title'"
        >
          @if (isPaymentAddressStructured) {
          <app-payment-address
            [buildingNameControl]="form.get('ultimateBeneficiaryBuildingName')"
            [buildingNameMaxLength]="STRUCTURED_ADDRESS_BUILDING_NAME_MAX_LENGTH"
            [buildingNumberControl]="form.get('ultimateBeneficiaryBuildingNumber')"
            [buildingNumberMaxLength]="STRUCTURED_ADDRESS_BUILDING_NUMBER_MAX_LENGTH"
            [cityControl]="form.get('ultimateBeneficiaryCity')"
            [cityMaxLength]="STRUCTURED_ADDRESS_CITY_MAX_LENGTH"
            [countryControl]="form.get('ultimateBeneficiaryCountry')"
            [postalCodeControl]="form.get('ultimateBeneficiaryPostalCode')"
            [postalCodeMaxLength]="STRUCTURED_ADDRESS_POSTAL_CODE_MAX_LENGTH"
            [showPostalCodeRequiredInfoIcon]="swiftPaymentBicNamingAndPostalCodeInfoEnabled"
            [provinceControl]="form.get('ultimateBeneficiaryProvince')"
            [provinceMaxLength]="STRUCTURED_ADDRESS_PROVINCE_MAX_LENGTH"
            [streetControl]="form.get('ultimateBeneficiaryStreetName')"
            [streetMaxLength]="STRUCTURED_ADDRESS_STREET_NAME_MAX_LENGTH"
            [structuredAddressEnabled]="isPaymentAddressStructured"
            data-cy="ultimate-beneficiary-address"
          ></app-payment-address>
          } @else {
          <app-payment-address
            [cityControl]="form.get('ultimateBeneficiaryCity')"
            [countryControl]="form.get('ultimateBeneficiaryCountry')"
            [postalCodeControl]="form.get('ultimateBeneficiaryPostalCode')"
            [showPostalCodeRequiredInfoIcon]="swiftPaymentBicNamingAndPostalCodeInfoEnabled"
            [provinceControl]="form.get('ultimateBeneficiaryProvince')"
            data-cy="ultimate-beneficiary-address"
          ></app-payment-address>
          }
        </app-collapse>
      </app-collapse>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('swiftXmlAdditionalBankIdentification', additionalBankIdentificationSectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlAdditionalBankIdentification', $event)"
        [headerKey]="'payment.receiverInfo.additionalBankIdentification.title'"
      >
        <nz-form-label translate> payment.receiverInfo.additionalBankIdentification.additionalBankIdentificationCodeType.label </nz-form-label>
        <nz-form-item>
          <nz-select
            [nzPlaceHolder]="'payment.receiverInfo.additionalBankIdentification.additionalBankIdentificationCodeType.placeholder' | translate: locale.language"
            formControlName="additionalBeneficiaryBankCodeType"
            nzShowSearch
            nzSize="large"
          >
            @for (bankCodeType of bankCodeTypes$ | async; track bankCodeType.id) {
            <nz-option [nzLabel]="bankCodeType.label" [nzValue]="bankCodeType.id"></nz-option>
            }
          </nz-select>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label translate> payment.receiverInfo.additionalBankIdentification.additionalBankIdentificationCode.label </nz-form-label>
          <nz-form-control>
            <input
              [maxlength]="config.paymentCodeMaxLength"
              [placeholder]="'payment.receiverInfo.additionalBankIdentification.additionalBankIdentificationCode.placeholder' | translate: locale.language"
              formControlName="additionalBeneficiaryBankCode"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
      </app-collapse>
      <app-collapse
        [active]="isAdditionalInfoSectionActive('swiftXmlCorrespondentBank', correspondentBankSectionControlNames)"
        (activeChange)="onAdditionalInfoSectionActiveChange('swiftXmlCorrespondentBank', $event)"
        [headerKey]="'payment.receiverInfo.correspondentBank.title'"
      >
        <app-correspondent-bank-information
          (institutionSelected)="onInstitutionSelect($event, 'correspondentBankName', 'correspondentBankAddress', 'correspondentBankCountry')"
          [config]="config"
          [correspondentBankCodeControl]="form.get('correspondentBankCode')"
          [correspondentBankNameControl]="form.get('correspondentBankName')"
          [useSwiftBicCodeLabel]="swiftPaymentBicNamingAndPostalCodeInfoEnabled"
        ></app-correspondent-bank-information>
        <app-payment-address
          [addressControl]="form.get('correspondentBankAddress')"
          [countryControl]="form.get('correspondentBankCountry')"
          addressLabel="payment.receiverInfo.correspondentBank.address.label"
          addressPlaceholder="payment.receiverInfo.correspondentBank.address.placeholder"
          countryLabel="payment.receiverInfo.correspondentBank.country.label"
          countryPlaceholder="payment.receiverInfo.address.country.placeholder"
          data-cy="correspondent-bank-address"
        ></app-payment-address>
        <nz-form-item>
          <nz-form-label translate>payment.receiverInfo.correspondentBank.account.label</nz-form-label>
          <nz-form-control>
            <input
              [maxlength]="config.beneficiaryAccountNumberMaxLength"
              [placeholder]="'payment.receiverInfo.correspondentBank.account.placeholder' | translate: locale.language"
              formControlName="accountWithBankCorrespondent"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label translate> payment.receiverInfo.additionalBankIdentification.additionalCorrespondentBankCodeType.label </nz-form-label>
          <nz-form-control>
            <nz-select
              [nzPlaceHolder]="'payment.identification.type.selectPlaceholder'  | translate: locale.language"
              formControlName="additionalBeneficiaryCorrespondentBankCodeType"
              nzShowSearch
              nzSize="large"
            >
              @for (bankCodeType of bankCodeTypes$ | async; track bankCodeType.id) {
              <nz-option [nzLabel]="bankCodeType.label" [nzValue]="bankCodeType.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label translate> payment.receiverInfo.additionalBankIdentification.additionalCorrespondentBankCode.label </nz-form-label>
          <nz-form-control>
            <input
              [maxlength]="config.paymentCodeMaxLength"
              [placeholder]="'payment.receiverInfo.additionalBankIdentification.additionalCorrespondentBankCode.placeholder' | translate: locale.language"
              formControlName="additionalBeneficiaryCorrespondentBankCode"
              nz-input
              nzSize="large"
              type="text"
            />
          </nz-form-control>
        </nz-form-item>
      </app-collapse>
      }
      <ng-container *ngTemplateOutlet="submitTemplate"></ng-container>
    </div>
    }

    <ng-template #scheduledPaymentTemplate>
      <app-scheduled-payment
        [editStandingOrderId]="payment?.editStandingOrderId"
        [scheduledControl]="form.get('scheduled')"
        [scheduledEndDateControl]="form.get('tillDate')"
        [scheduledFrequencyControl]="form.get('periodType')"
        [scheduledPaymentsEnabled]="config.scheduledPaymentsEnabled && !isGatewayPaymentInitiated"
        [scheduledStartDateControl]="form.get('fromDate')"
      ></app-scheduled-payment>
    </ng-template>
  </form>
</div>

<ng-template #submitTemplate>
  <div class="app-bank-transfer-form-buttons">
    <app-alert [userAgreementControl]="alertAgreementControl" #alertRef [form]="form"></app-alert>
    <button
      [disabled]="isSubmitButtonDisabled(submitButtonDisabled$ | async)"
      [nzLoading]="submitButtonLoading$ | async"
      data-cy="payment-submit-button"
      nz-button
      nzSize="large"
      nzType="primary"
      type="submit"
    >
      {{ (payment?.editStandingOrderId ? 'payment.updatePayment' : 'payment.makePayment') | translate: locale.language }}
    </button>

    @if ((saveButtonVisible$ | async) && canBeSaved()) {
    <button
      (click)="save()"
      [disabled]="isSaveButtonDisabled(saveButtonDisabled$ | async)"
      [nzLoading]="saveButtonLoading$ | async"
      nz-button
      nzType="link"
      translate
      type="button"
    >
      payment.save
    </button>
    }
  </div>
</ng-template>

<ng-template #beneficiaryIdentificationTemplate>
  <app-payment-identification
    [birthDateControl]="form.get('beneficiaryBirthDate')"
    [cityOfBirthControl]="form.get('beneficiaryCityOfBirth')"
    [countryOfBirthControl]="form.get('beneficiaryCountryOfBirth')"
    [idControl]="form.get('beneficiaryId')"
    [identificationClassControl]="form.get('beneficiaryIdentification')"
    [identificationCodeTypeControl]="form.get('beneficiaryIdentificationCodeType')"
    [identificationTypeControl]="form.get('beneficiaryIdentificationType')"
    [label]="'payment.receiverInfo.identification.title' | translate: locale.language"
    [placeholder]="'payment.receiverInfo.identification.placeholder' | translate: locale.language"
    [provinceOfBirthControl]="form.get('beneficiaryProvinceOfBirth')"
    [paymentType]="paymentConditions?.operationType"
    [prefilledControls]="gatewayPrefilledControls"
    [allowedClasses]="allowedBeneficiaryIdentificationValues"
    [hideIdentificationClass]="isGatewayPaymentInitiated"
    [hideOtherTypeIdControl]="isGatewayPaymentInitiated"
  ></app-payment-identification>
</ng-template>

<ng-template #ultimateBeneficiaryIdentificationTemplate>
  <app-payment-identification
    [birthDateControl]="form.get('ultimateBeneficiaryBirthDate')"
    [cityOfBirthControl]="form.get('ultimateBeneficiaryCityOfBirth')"
    [countryOfBirthControl]="form.get('ultimateBeneficiaryCountryOfBirth')"
    [idControl]="form.get('ultimateBeneficiaryId')"
    [identificationClassControl]="form.get('ultimateBeneficiaryIdentification')"
    [identificationCodeTypeControl]="form.get('ultimateBeneficiaryIdentificationCodeType')"
    [identificationTypeControl]="form.get('ultimateBeneficiaryIdentificationType')"
    [label]="'payment.receiverInfo.identify.title' | translate: locale.language"
    [placeholder]="'payment.receiverInfo.identify.placeholder' | translate: locale.language"
    [provinceOfBirthControl]="form.get('ultimateBeneficiaryProvinceOfBirth')"
    [paymentType]="paymentConditions?.operationType"
    [prefilledControls]="gatewayPrefilledControls"
  ></app-payment-identification>
</ng-template>

<ng-template #payerIdentificationTemplate>
  <app-payment-identification
    [birthDateControl]="form.get('payerBirthDate')"
    [cityOfBirthControl]="form.get('payerCityOfBirth')"
    [countryOfBirthControl]="form.get('payerCountryOfBirth')"
    [idControl]="form.get('payerId')"
    [identificationClassControl]="form.get('payerIdentification')"
    [identificationCodeTypeControl]="form.get('payerIdentificationCodeType')"
    [identificationTypeControl]="form.get('payerIdentificationType')"
    [label]="'payment.payerInfo.payerIdentification.title' | translate: locale.language"
    [placeholder]="'payment.identification.classifier.placeholder' | translate: locale.language"
    [provinceOfBirthControl]="form.get('payerProvinceOfBirth')"
    [paymentType]="paymentConditions?.operationType"
    [prefilledControls]="gatewayPrefilledControls"
    [allowedClasses]="allowedPayerIdentificationValues"
    [identificationTypeDefault]="payerIdentificationTypeDefault"
  ></app-payment-identification>
</ng-template>

<ng-template #initialPayerIdentificationTemplate>
  <app-payment-identification
    [birthDateControl]="form.get('initialPayerBirthDate')"
    [cityOfBirthControl]="form.get('initialPayerCityOfBirth')"
    [countryOfBirthControl]="form.get('initialPayerCountryOfBirth')"
    [idControl]="form.get('initialPayerId')"
    [identificationClassControl]="form.get('initialPayerIdentification')"
    [identificationCodeTypeControl]="form.get('initialPayerIdentificationCodeType')"
    [identificationTypeControl]="form.get('initialPayerIdentificationType')"
    [label]="'payment.payerInfo.identify.title' | translate: locale.language"
    [placeholder]="'payment.payerInfo.identify.placeholder' | translate: locale.language"
    [provinceOfBirthControl]="form.get('initialPayerProvinceOfBirth')"
    [paymentType]="paymentConditions?.operationType"
    [prefilledControls]="gatewayPrefilledControls"
  ></app-payment-identification>
</ng-template>
